import { Injectable } from '@angular/core';
import { ResetPasswordContent } from '@com-delta-idp/mnx-login-ui';
import { LoginHelperUtils } from '../../../utils/login-helper.utils';
import { LoginModalContent } from '../../models/aem';
import { CreatePasswordHelperService } from '../../services';
import { ResetPasswordAdapter } from '../reset-password/reset-password.adapters';

@Injectable({
  providedIn: 'root'
})
export class CreatePasswordAdapter extends ResetPasswordAdapter {
  constructor(
    protected helper: CreatePasswordHelperService,
    protected loginHelperUtils: LoginHelperUtils
  ) {
    super(helper, loginHelperUtils);
  }

  getCreatePasswordContent(
    loginAemResponse: LoginModalContent
  ): ResetPasswordContent {
    return {
      formGroup: this.helper.createForm(),
      formAttributes: this.helper.getFormAttributes(),
      pageContent: this.helper.getCreatePasswordPageContent(loginAemResponse),
      hasError: false,
      errorMessage: ''
    };
  }
}
